import BillboardText from './BillboardText'

export default BillboardText
